import { render, staticRenderFns } from "./journal-add.vue?vue&type=template&id=5f9b5254&scoped=true&"
import script from "./journal-add.vue?vue&type=script&lang=js&"
export * from "./journal-add.vue?vue&type=script&lang=js&"
import style0 from "./journal-add.vue?vue&type=style&index=0&id=5f9b5254&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=5f9b5254&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b5254",
  null
  
)

component.options.__file = "journal-add.vue"
export default component.exports